jQuery(document).ready(function ($) {
    //Page Loading Process...
    $('body.template-index.loading .loading .ready').fadeIn(1000);
    $(window).on('load', function () {

        if ($('body').hasClass('template-index') && window.location.hash !== '#connect') {
            setTimeout(function () { window.scrollTo(0, 0); }, 1000);
        }

        $('body').addClass('go');
        setTimeout(function () {
            $('body.template-index.loading .loading').fadeOut(1000, function () {
                $('body').removeClass('loading');
            });
        }, 1000);
    });

    $('.bottle-filter').on('click', 'div', function () {
        $('.bottle-filter .active').removeClass('active');
        $(this).addClass('active');
        const trigger = $(this).data('trigger');
        console.log(trigger);
        $('.list-view-items').attr('data-show', trigger);
    });
    //If it's taking too long to load...
    setTimeout(function () {
        if ($('body').hasClass('loading')) {
            $('body .loading').fadeOut(1000);
            console.log('forced unloading');
        }

    }, 5000);

    checkScroll();
    $(window).scroll(function (event) {
        checkScroll();
        // Do something
    });

    //if page loads and there's an anchor (that exists), scroll to it
    if (window.location.hash && document.getElementById(window.location.hash.substring(1) + '_anchor')) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(window.location.hash + '_anchor').offset().top - 99
            }, 500);
        }, 1000);
    }

    var executed = false;

    //PRICE CHANGE
    $('#stamped-reviews-widget').on('DOMSubtreeModified', function () {
        if ($(this).find('.stamped-reviews-message').length > 0) {
            var doReviewTrim = (function () {
                return function () {
                    if (!executed) {
                        executed = true;
                        trimReviews();
                        // do something
                    }
                };
            })();
            doReviewTrim(); // "do something" happens
        }
    });


    $('body').on('click', 'div#stamped-reviews-widget .trimmed .more', function () {
        var daddy = $(this).parent().parent('.trimmed');
        more = daddy.find('.original');
        less = daddy.find('.trim');
        less.hide();
        more.show();
    });

    $('body').on('click', 'div#stamped-reviews-widget .trimmed .less', function () {
        var daddy = $(this).parent().parent('.trimmed');
        more = daddy.find('.original');
        less = daddy.find('.trim');
        more.hide();
        less.show();
    });


    $('body').on('click', '.stamped-carousel-buttons *', function () {
        $('div#stamped-reviews-widget .trimmed .original').hide();
        $('div#stamped-reviews-widget .trimmed .trim').show();
    });

    $('body').on('DOMSubtreeModified', '.product__price', function () {
        // Check if thisproduct is defined, otherwise return
        if (!window.thisproduct || !thisproduct.compare_at_price_varies) {
            return false;
        }
        var startingPrice = clearSpaces($('.price__sale dd.original s').html());
        if (startingPrice == '') {
            var str = thisproduct.price.toString();
            var originalprice = '$' + str.substring(0, str.length - 2) + "." + str.substring(str.length - 2);
            $('.price__sale dd.original s').html(originalprice)
        }
        var currentPrice = clearSpaces($('.price__sale dd.current span').html());
        if (startingPrice == currentPrice) {
            $('.price__regular').show();
            $('.price__sale').hide();
        } else {
            $('.price__regular').hide();
            $('.price__sale').css('display', 'flex');
        }
    });



    //SHARE BUTTON
    const shareButton = document.querySelector('.share-button');
    const shareDialog = document.querySelector('.share-dialog');
    const closeButton = document.querySelector('.close-button');
    if (shareButton) {

        shareButton.addEventListener('click', event => {
            if (navigator.share) {
                navigator.share({
                    title: document.title,
                    url: window.location.href
                }).then(() => {
                    console.log('Thanks for sharing!');
                })
                    .catch(console.error);
            } else {
                shareDialog.classList.add('is-open');
            }
        });

        closeButton.addEventListener('click', event => {
            shareDialog.classList.remove('is-open');
        });
    }


    //GET FIRST WORD OF TITLES (to break into two lines)
    $('.product-single__title, .product-title').each(function () {
        var me = $(this);
        var text = me.text();
        var type = me.data('type');
        var typeHTML = '';
        if (me.hasClass('shop-spotlight')) {
            typeHTML = type !== null ? '<span class="type">' + me.data('type') + '</span>' : '';
            //Remove the words "still" and "sparkling" from the title. Make it not case sensitive.
            text = text.replace(/still/i, '');
            text = text.replace(/sparkling/i, '');
        }
        //If there's an opening parentheses, split it there. Otherwise, split after the first word.
        if (text.includes('(')) {
            first = text.substring(0, text.indexOf('('));
            second = text.split(first)[1];
            t = [first, second];
        } else {
            t = text.split(' ');
        }

        me.html('<span class="first-word">' + t.shift() + typeHTML + '</span> ' + t.join(' '));
    });





    /*PRODUCT PAGES*/
    //Parse Json and setup Global product object "thisproduct"
    productSetup();


    /*Custom Selector. Reverse-engineering the Single Option Variants, so as to hook into that code.*/
    $('.custom_selector_wrap div').on('click', function () {
        // Check if thisproduct is defined, otherwise return
        if (!window.thisproduct) {
            return false;
        }
        //Setup info
        var variantid = $(this).data('variant');
        var variant = thisproduct.variants.find(x => x.id === variantid)
        var totaloptions = parseInt($(this).data('options'));
        var start = 0;
        var options = [];
        //Get all the options and add them to an array
        while (totaloptions > start) {  // note: 0 is falsy
            (function () {
                start++;
                //Get appropriate Data
                dataindex = 'option-' + start;
                options.push(dataindex);
            })(totaloptions);
        }
        start = 0;
        //Set individual options to appropriate values.
        for (option of options) {
            data = $(this).data(option);
            single_selector = 'SingleOptionSelector-' + start;
            single_obj = $('#' + single_selector);
            single_obj.val(data);

            //Change the actual "selected" element html
            single_obj.children().each(function () {
                if ($(this).attr('value') == data) {
                    $(this).attr('selected', 'selected');
                } else {
                    $(this).removeAttr('selected');
                }
            });

            single_obj.change();



            //Trigger variantchange event that makes it all tick
            document.getElementById(single_selector).dispatchEvent(
                new CustomEvent('variantChange', {
                    detail: {
                        variant: variant
                    },
                    bubbles: true,
                    cancelable: true
                })
            );
            //Trigger Change Event (essential for deeplink update and recharge integration)
            document.getElementById(single_selector).dispatchEvent(
                new CustomEvent('change')
            );
            start++;
        }
        //Update Master Variant Selector
        $('#ProductSelect-product-template').val(variantid).change();
        //Update Custom Selector
        $('.custom_selector.active').removeClass('active');
        $(this).addClass('active');
    });



    /*RECHARGE FIX*/
    //For some reason, their subscribe button doesn't have an id and clicking the label doesn't work!
    $('#shopify-section-legacy-product-template').on('click', '.rc_widget__option__selector label', function () {
        if ($(this).attr('for')) {
            //do nothing
        } else {
            $(this).siblings('input').click();
        }
    });



    //DIRECT CHECKOUT BUTTON
    $('#direct').on('click', function () {
        window.direct = true;
    })


    //Smooth Scroll on ANCHOR click
    $(document).on('click', 'a[href^="#"]', function (event) {
        if ($($.attr(this, 'href')).length > 0) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 99
            }, 500);
        }
    });

    //Smooth Scroll on ANCHOR click
    $('a[href*="pages/wholesale"]').attr('target', '_blank');
    $('a[href*="buzzbassadorapp"]').attr('target', '_blank');





    /******MOBILE FUNCTIONS******/
    /*Home Icons*/
    $('.infocon').on('click', function () {
        $('.infocon.active').removeClass('active');
        $(this).addClass('active');
        var block = $(this).data('block');
        showInfo(block);

    });

    if ($('.infocon').length > 0) {
        $('.infocon').first().click();
    }


    /*Our Water InfoBox (Infobox One)*/
    $('.splendor-info-one .expander').on('click', function () {
        $('.splendor-info-one').toggleClass('expanded');
    });

    /*Social Responsibility (Infobox One)*/
    $('.splendor-info-two .expander').on('click', function () {
        $('.splendor-info-two').toggleClass('expanded');
    });


    /*Our Water Gradient Box Sections*/
    $('.custom_content.style-gradient .spotlight-image.spotlight-left .sections .section .body').each(function () {
        var elem = $(this).find('p').first();
        var textParts = elem.html().split(".");
        var first = "<span class='teaser'>" + textParts.shift() + ".</span>";
        elem.html(first + textParts.join("."));
        papa = $(this).parent('.section').find('.head').append(first);
    });

    /*Basic Sections*/
    $('.section.collapse').on('click', '.head, .expander', function () {
        $(this).parent('.section').first().toggleClass('expanded');
    });

    $('.section.collapse').each(function () {
        $(this).append('<div class="mobil expander"><div class="plus">+</div><div class="minus">-</div>');
    });



});
